module.exports = __webpack_public_path__ + "assets/img/5_1134_big.09a0a691.jpg";